<template>
    <div class="body">
        <div style="margin-bottom: 3rem;">
            <div style="text-align: center; font-size: 2rem; font-weight: bold; margin-bottom: 1rem;">
                移动积分兑换
            </div>

            <div style="margin-bottom: 1rem;">
                <div style="font-weight: bold;">请选择要兑换的商品类别及商品：</div>
                <van-tabs>
                    <van-tab v-for="item in goodsClassList" :key="item">
                        <div slot="title" @click="clickTab(item)">{{goodsClassMap[item].name}}</div>
                        <van-radio-group v-model="query.goodsId">
                            <van-radio v-for="(value2,key2) in goodsClassMap[query.goodsClass].goodsMap" :key="key2"
                                       :name="key2">
                                {{value2}}
                            </van-radio>
                        </van-radio-group>
                    </van-tab>
                </van-tabs>
            </div>

            <div style="font-weight: bold;">请输入兑换手机号：</div>
            <van-field v-model="query.phone" placeholder="注意，手机号输错无法回款" clearable/>

            <van-button round size="large" type="warning" @click="exchange">兑换</van-button>
        </div>

        <van-row>
            1、<span style="font-weight: bold;">兑换区域：</span>{{goodsClassMap[query.goodsClass].area}}
            （不同商品类别兑换区域不同）
        </van-row>
        <van-row>
            2、<span style="font-weight: bold;">兑换步骤：</span>先查积分，再输入手机号，生成需要发送的短信
            （可二维码快捷发短信），然后根据内容回复数字确认兑换，就ok了
        </van-row>
        <van-row>
            3、如分值较多，采用多次多个类别兑换
        </van-row>
        <van-row>
            4、如果确定积分扣了，也回复短信了，系统会每隔1个小时再次更新订单状态
        </van-row>
        <van-row>
            5、不能先发短信，再生成二维码报单！这种无法回款！
        </van-row>
        <van-row>
            6、号码出错无法回款！必须先输入手机号，生成二维码再发短信扣积分，否则也无法回款！
        </van-row>
        <van-row>
            7、本平台禁止外呼电话营销兑换，一经核实立即报警，永久冻结账号，请自律！
        </van-row>
        <p>
            <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O7nd4B0.png"/>
        </p>

        <van-dialog v-model="qrLinkVisible" style="width: 70%;">
            <p>
                <img :src="qrLink"/>
            </p>
        </van-dialog>
    </div>
</template>

<script>
    import creditAPI from '@/api/credit';

    export default {
        data() {
            return {
                goodsClassList: ["10125", "10120", "10121", "73", "70"],
                goodsClassMap: {
                    "70": {
                        name: "懒人",
                        area: "支持全国部分区域(广东,云南不可兑换)",
                        goodsMap: {
                            "1477": "懒人8.75面值（1050积分）",
                            "1478": "懒人26.08面值（3130积分）",
                            "1479": "懒人43.5面值（5220积分）",
                            "1480": "懒人86.92面值（10430积分）",
                            "1481": "懒人130.33面值（15640积分）",
                            "1482": "懒人173.75面值（20850积分）",
                        },
                    },
                    "71": {
                        name: "骏和",
                        area: "四川,湖南,广东,甘肃,贵州,黑龙江,江苏",
                        goodsMap: {
                            "347": "骏和3.7面值（440积分）",
                            "348": "骏和8.25面值（990积分）",
                            "349": "骏和18.3面值（5220积分）",
                            "350": "骏和55面值（6600积分）",
                            "351": "骏和82.5面值（9900积分）",
                            "562": "骏和183.3面值（22000积分）",
                        },
                    },
                    "72": {
                        name: "空空",
                        area: "福建,甘肃,贵州,河南,黑龙江,湖南,江西,内蒙古,山东,陕西,四川,西藏,云南,浙江",
                        goodsMap: {
                            "371": "空空3.3面值（400积分）",
                            "372": "空空25面值（3000积分）",
                        },
                    },
                    "73": {
                        name: "都市",
                        area: "福建,甘肃,贵州,河南,黑龙江,湖南,江西,内蒙古,山东,陕西,四川,西藏,云南,浙江",
                        goodsMap: {
                            "375": "都市5面值（600积分）",
                            "376": "都市6.7面值（800积分）",
                            "377": "都市8.4面值（1000积分）",
                            "378": "都市12.5面值（1500积分）",
                            "379": "都市25面值（3000积分）",
                        },
                    },
                    "92": {
                        name: "来来",
                        area: "安徽,广东,河北,湖南,山东,北京,吉林,内蒙古,福建,贵州,黑龙江,江苏,陕西,甘肃,湖北,江西,青海",
                        goodsMap: {
                            "788": "来来4.34面值（520积分）",
                            "789": "来来8.58面值（1030积分）",
                            "790": "来来17.17面值（2060积分）",
                            "791": "来来25.75面值（3090积分）",
                            "792": "来来42.83面值（5140积分）",
                        },
                    },
                    "980": {
                        name: "风行",
                        area: "安徽,北京,福建,甘肃,广东,广西,贵州,海南,河北,河南,黑龙江,湖北,湖南,吉林,江苏,江西," +
                        "内蒙古,宁夏,青海,山东,陕西,上海,天津,西藏,新疆,云南,浙江",
                        goodsMap: {
                            "2453": "风行4.41面值（530积分）",
                            "2454": "风行8.75面值（1050积分）",
                            "2455": "风行26.08面值（3130积分）",
                            "2456": "风行43.5面值（5220积分）",
                            // "2457": "风行86.92面值（10430积分）",
                            "2458": "风行173.75面值（20850积分）",
                            "2459": "风行434.42面值（52130积分）",
                        },
                    },
                    "981": {
                        name: "爱体育",
                        area: "安徽,河北,湖南,山东,北京,广西,河南,吉林,内蒙古,天津,浙江,福建,贵州,黑龙江,江苏,陕西," +
                        "西藏,甘肃,海南,湖北,青海,上海,新疆,云南",
                        goodsMap: {
                            "2460": "爱体育5.25面值（630积分）",
                            "2461": "爱体育15.67面值（1880积分）",
                            "2462": "爱体育21.75面值（2610积分）",
                            "2463": "爱体育62.58面值（7510积分）",
                            "2464": "爱体育172.08面值（20650积分）",
                            "2465": "爱体育693.33面值（83200积分）",
                        },
                    },
                    "990": {
                        name: "航班",
                        area: "河北,吉林,黑龙江,江苏,浙江,安徽,福建,江西,山东,湖北,湖南,广东,海南,四川,贵州,云南," +
                        "陕西,甘肃,青海,内蒙古,广西,西藏,新疆,天津,上海,浙江,云南,广西",
                        goodsMap: {
                            "2513": "航班4.41面值（530积分）",
                            "2514": "航班42.58面值（5110积分）",
                            "2515": "航班86.08面值（10330积分）",
                            "2516": "航班172.91面值（20750积分）",
                        },
                    },
                    "991": {
                        name: "闪送",
                        area: "安徽,北京,福建,甘肃,广东,广西,贵州,海南,河北,河南,黑龙江,湖北,湖南,吉林,江苏,江西," +
                        "内蒙古,青海,山东,陕西,上海,四川,天津,新疆,云南,浙江",
                        goodsMap: {
                            "2511": "闪送8.75面值（1050积分）",
                            "2512": "闪送17.41面值（2090积分）",
                        },
                    },
                    "10120": {
                        name: "幸福",
                        area: "北京,天津,河北,内蒙古,黑龙江,吉林,上海,江苏,山东,湖南,福建,西藏,甘肃,青海,广东,新疆,浙江",
                        goodsMap: {
                            "2895": "幸福西饼8.75面值（1050积分）",
                            "2896": "幸福西饼17.5面值（2100积分）",
                            "2897": "幸福西饼43.75面值（5250积分）",
                            "2898": "幸福西饼87.5面值（10500积分）",
                            "2899": "幸福西饼175面值（21000积分）",
                        },
                    },
                    "10121": {
                        name: "哈根",
                        area: "北京,天津,河北,内蒙古,黑龙江,吉林,上海,江苏,山东,湖南,福建,西藏,甘肃,青海,广东,新疆,浙江",
                        goodsMap: {
                            "2900": "哈根达斯4.41面值（530积分）",
                            "2901": "幸福西饼8.75面值（1050积分）",
                            "2902": "幸福西饼17.5面值（2100积分）",
                            "2903": "幸福西饼26.25面值（3150积分）",
                            "2904": "幸福西饼30.66面值（3680积分）",
                            "2905": "幸福西饼43.75面值（5250积分）",
                            "2906": "幸福西饼87.5面值（10500积分）",
                        },
                    },
                    "10125": {
                        name: "京东",
                        area: "北京,天津,河北,内蒙古,吉林,江苏,安徽,福建,湖南,广东,贵州,西藏,甘肃,青海,新疆",
                        goodsMap: {
                            "2924": "京东钢镚5面值（600积分）",
                            "2925": "京东钢镚10面值（1200积分）",
                            "2926": "京东钢镚20面值（2400积分）",
                            "2927": "京东钢镚50面值（6000积分）",
                            "2928": "京东钢镚100面值（12000积分）",
                            "2929": "京东钢镚200面值（24000积分）",
                        },
                    },
                },
                query: {
                    traderId: this.$route.query.traderId,
                    goodsId: "",
                    goodsName: "",
                    goodsClass: "10125",
                    phone: "",
                },
                qrLinkVisible: false,
                baseUrl: "http://zy.fenduoduo.vip",
                qrLink: "",
            }
        },
        methods: {
            clickTab(key) {
                this.query.goodsClass = key;
                this.query.goodsId = '';
            },
            exchange() {
                if (!this.query.traderId) {
                    this.$toast("页面参数有误，请重新进入页面");
                    return;
                }
                if (!this.query.goodsClass || !this.query.goodsId || !this.query.phone) {
                    this.$toast("请先填写信息");
                    return;
                }
                this.query.goodsName = this.goodsClassMap[this.query.goodsClass].goodsMap[this.query.goodsId];
                if (!this.query.goodsName) {
                    this.$toast("该商品不存在");
                    return;
                }
                if (!this.$myUtil.mobile(this.query.phone)) {
                    this.$toast("手机号不正确");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                creditAPI.exchange(this.query).then((result) => {
                    this.$toast.clear();
                    this.qrLink = this.baseUrl + result.data;
                    this.qrLinkVisible = true;
                }).catch(() => {
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .all {
        background-color: #FFFFFF;
    }

    .body {
        padding: 2rem 2rem;
        line-height: 2.5rem;
        p {
            text-align: center;
            color: #000000;
        }
        img {
            height: 25rem;
            width: 18rem;
        }

    }

</style>
